export const SPECIAL_MEMBER_OFFER_CONTENT = {
  hero: {
    offerText: 'Special Member Offer',
    title: 'Protection for the electronics you rely on every day',
    subtitle:
      'Cover many of the electronics in your home under one plan — with repair or replacement when qualified devices stop working, starting at $14.99 per month.†',
    image: 'assets/icons/cross-sell.svg',
  },

  content: {
    title: 'Get started protecting your home electronics',
    description:
      'This plan is separate from your home warranty and helps cover eligible electronics in your home — regardless of age or where they were purchased. Available online and over the phone.',
    highlightsTitle: 'Coverage highlights:',
    features: [
      'Repair or replacement of qualified electronics when they fail †',
      'No device age, brand, or purchase location restrictions',
      'Flexible plan options to fit your needs and budget',
      'Covers many commonly used devices, including TVs, laptops, tablets, gaming systems, and more',
      'Generous claim limits of up to $2,000 per claim and $5,000 annual coverage †',
      'Low deductible per claim',
    ],
  },

  contactCard: {
    title: 'Ready to get started?',
    description: 'Call us to enroll into Electronics Essentials Plan.',
    phone: '(XXX) XXX-XXXX',
    timing:
      'Mon–Fri Xam–Xpm EST • Sat Xam–Xpm EST • Closed Sundays',
  },

  supportCard: {
    text: 'For questions about an existing home warranty service request, please visit',
    linkText: 'Contact Us',
    phone: 'or call',
  },

  stepsSection: {
    title: 'Here’s how it works',
    subtitle: 'When a qualified electronic device stops working, your Electronics Essentials Plan helps make the process simple.',
    steps: [
      {
        step: '1',
        title: 'Submit a claim',
        description: 'Start a claim online or by phone when an eligible device experiences a covered failure.',
      },
      {
        step: '2',
        title: 'Pay your deductible',
        description: 'Once your claim is approved, pay deductible per claim.  Required for each approved claim.',
      },
      {
        step: '3',
        title: 'Repair or replacement',
        description: 'We’ll arrange for repair or replacement, depending on the device and service option, subject to plan limits.',
      },
    ],
  },

  cta: {
    title: 'Call us to get your electronics protected',
    description: 'Explore electronics protection options starting at $14.99 per month — and decide what coverage works best for you.† ',
    phone: '(XXX) XXX-XXXX',
    timing: 'Mon–Fri Xam–Xpm EST • Sat Xam–Xpm EST • Closed Sundays',
    subText: 'If you need to enquire about a service call',
  },

  tnc: {
    title: '† Subject to terms and conditions. Per claim and annual aggregate limits apply, including a deductible per claim. Coverage applies to qualified electronics only. Availability and coverage details may vary by plan.',
    description: 'Your service agreement is sold by Cinch Consumer Electronics, Inc., and administered by: LOTSolutions, Inc., 10751 Deerwood Park Blvd., Suite 200, Jacksonville, Florida 32256 (888) 910-4317. Products and services are provided by 4Warranty Corporation, The Service Doc, Inc. (in WI), or Lyndon Southern Insurance Company (in OK and FL: Lic. No.: FL-03698), each of which are subsidiaries of The Fortegra Group, Inc. Fortegra® is the marketing name for the service contract operations of the subsidiaries of The Fortegra Group, Inc. This is a summary of the benefits available. For complete information including details of benefits, coverage, specific exclusions, and limitations please refer to the complete terms and conditions of the service agreement. A service agreement is optional and cancelable. A service agreement is not a warranty.'
  }
};